import {
  CurrencyType,
  getLocationCurrencyFromCountryCode,
} from "../../../models/types/location-currency.types";
import { InstitutionAccountView } from "../../../models/view/institution/institution-account.view";
import {
  GLOSS_CREDITS_ACCOUNT_NAME,
  GLOSS_VAULT,
  OTHER,
} from "../../../models/constants/global.constants";
import { InstitutionView } from "../../../models/view/institution/institution.view";
import { DefaultInstitutionStoreModel } from "../../../models/store/institution.store.model";

export const getDefaultAccount = (
  institutionId: string,
  locationCurrency: CurrencyType,
): InstitutionAccountView => {
  return {
    name: OTHER,
    interestRates: [
      {
        range: -1,
        banded: false,
        rate: 0,
        symbol: locationCurrency,
        last_updated: "",
        condition_intrinsic_desc: "",
        condition_action_desc: "",
      },
    ],
    id: `${institutionId}-unknown-account-id`,
  };
};

const OTHER_INSTITUTION_ID_PREFIX = "unknown-institution-id-";

/** The synthetic "Other" institution: createOtherInstitution's, and the Plaid/Fiskil fallback
 * (getOtherInstitutionId("US") / ("AU")) a synced account lands on when its institution can't be
 * resolved. */
export const isOtherInstitutionId = (institutionId?: string): boolean =>
  !!institutionId?.startsWith(OTHER_INSTITUTION_ID_PREFIX);

export const getOtherInstitutionId = (countryCode: string): string =>
  `${OTHER_INSTITUTION_ID_PREFIX}${countryCode}`;

export const createOtherInstitution = (countryCode: string): InstitutionView => {
  const locationCurrency = getLocationCurrencyFromCountryCode(countryCode);
  const institution = new InstitutionView({
    ...DefaultInstitutionStoreModel,
    id: getOtherInstitutionId(countryCode),
  });
  institution.availableAccounts[0] = getDefaultAccount(institution.id, locationCurrency);
  institution.name = OTHER;
  applyOtherSwiftDefaults(institution, countryCode);
  return institution;
};

/** Placeholder swift for synthetic institutions ("Other" and per-plugin) that no bank backs. */
export const applyOtherSwiftDefaults = (
  institution: InstitutionView,
  countryCode: string,
): void => {
  institution.swift.bankCode = "XXX";
  institution.swift.countryCode = countryCode;
  institution.swift.branchCode = "YYY";
  institution.swift.locationCode = countryCode;
};

export const getGlossVaultAccount = (
  institutionId: string,
  locationCurrency: CurrencyType,
): InstitutionAccountView => {
  return {
    name: GLOSS_CREDITS_ACCOUNT_NAME,
    institutionName: GLOSS_VAULT,
    interestRates: [
      {
        range: -1,
        banded: false,
        rate: 0,
        symbol: locationCurrency,
        last_updated: "",
        condition_intrinsic_desc: "",
        condition_action_desc: "",
      },
    ],
    id: `${institutionId}-gloss-credits-account-id`,
  };
};
